import React from 'react';
import Contact from '../components/Contact/Contact';
import './PageStyles.css';

const ContactPage: React.FC = () => {
  return (
    <div className="page-wrapper">
      <Contact />
    </div>
  );
};

export default ContactPage;
